export enum ButtonSize {
	Medium = "Medium",
	Large = "Large",
}
